import React from 'react';
import { AlertTriangleIcon, ArrowRightIcon, XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function BigMistake() {
  return <section className="py-10 md:py-20 px-4 bg-slate-900 text-white relative overflow-hidden" data-id="element-35">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-kid-purple via-kid-pink to-kid-sky" data-id="element-36"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-37">
        <FadeIn data-id="element-38">
          <div className="text-center mb-8 md:mb-16" data-id="element-39">
            <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-kid-rose/10 text-kid-rose mb-5 md:mb-8 border border-kid-rose/20" data-id="element-40">
              <AlertTriangleIcon className="w-7 h-7 md:w-8 md:h-8" data-id="element-41" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-white" data-id="element-42">
              El error que cometen la mayoría de los métodos
            </h2>
            <p className="text-base md:text-lg text-slate-400 font-normal" data-id="element-43">
              Muchos métodos enseñan primero:
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-44">
          <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 md:p-16 mb-8 md:mb-16 relative overflow-hidden" data-id="element-45">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-10 text-lg md:text-2xl font-semibold text-slate-300 relative z-10" data-id="element-46">
              <div className="px-6 py-3 md:px-8 md:py-4 bg-slate-900/80 rounded-xl border border-kid-rose/40 text-kid-rose line-through decoration-2 shadow-lg" data-id="element-47">
                Palabra
              </div>
              <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-pink rotate-90 md:rotate-0" data-id="element-48" />
              <div className="px-6 py-3 md:px-8 md:py-4 bg-slate-900/80 rounded-xl border border-kid-rose/40 text-kid-rose line-through decoration-2 shadow-lg" data-id="element-49">
                Sílabas
              </div>
              <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-pink rotate-90 md:rotate-0" data-id="element-50" />
              <div className="px-6 py-3 md:px-8 md:py-4 bg-slate-900/80 rounded-xl border border-kid-rose/40 text-kid-rose line-through decoration-2 shadow-lg" data-id="element-51">
                Repetición
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center" data-id="element-52">
          <FadeIn direction="right" className="w-full md:w-1/2" data-id="element-53">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/2] max-w-md mx-auto bg-slate-950 flex flex-col items-center justify-center border-2 border-kid-rose/40 shadow-[0_0_30px_rgba(244,63,94,0.15)]" data-id="element-54">
              <div className="text-center p-6 md:p-8 flex flex-col items-center" data-id="element-55">
                <XIcon className="w-12 h-12 md:w-16 md:h-16 text-kid-rose mb-3 md:mb-4" data-id="element-56" />
                <p className="text-kid-rose font-bold text-lg md:text-2xl uppercase tracking-wider" data-id="element-57">
                  Método tradicional
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" className="w-full md:w-1/2" data-id="element-58">
            <div className="bg-slate-800/30 p-6 md:p-8 rounded-2xl border border-slate-700/50" data-id="element-59">
              <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6 text-slate-200 leading-tight" data-id="element-60">
                Pero el cerebro infantil no aprende así.
              </h3>

              <p className="text-sm md:text-base text-slate-400 mb-4 md:mb-6 font-normal" data-id="element-61">
                Cuando el orden no es correcto:
              </p>

              <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-62">
                {['el niño se confunde', 'pierde confianza', 'se frustra', 'evita practicar'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-sm md:text-base text-slate-300 font-medium" data-id="element-63">
                    <XIcon className="w-5 h-5 text-kid-rose flex-shrink-0" data-id="element-64" />
                    <span data-id="element-65">{item}</span>
                  </li>)}
              </ul>

              <div className="p-4 md:p-6 bg-slate-800/50 border-l-4 border-kid-pink rounded-r-xl" data-id="element-66">
                <p className="text-sm md:text-lg font-medium text-slate-200 leading-relaxed" data-id="element-67">
                  <span className="block mb-1 text-slate-400" data-id="element-68">
                    No es que tu hijo no pueda aprender.
                  </span>
                  <span className="text-kid-pink block" data-id="element-69">
                    Es que el proceso está en el orden equivocado.
                  </span>
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}